import React from "react";
import { useLocation } from "react-router-dom";
import ReactTicker from "react-ticker";
import { checkForOverride } from "../helpers/theme";
import {
	ReplaceWithDataSource,
} from "../helpers/variable";

export default function Ticker({ cue, baseTheme, baseThemeId }) {
	const isPreview = useLocation().pathname.includes("/preview/");

	return (
		<>
			<span
				style={{
					fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
					color: checkForOverride(
						baseTheme,
						"ticker",
						cue.preset,
						"h1",
						"colour"
					),
					fontWeight:
						checkForOverride(baseTheme, "ticker", cue.preset, "h1", "bold") ===
						true
							? "bold"
							: "normal",
					fontStyle:
						checkForOverride(
							baseTheme,
							"ticker",
							cue.preset,
							"h1",
							"italic"
						) === true
							? "italic"
							: "normal",
					textDecoration:
						checkForOverride(
							baseTheme,
							"ticker",
							cue.preset,
							"h1",
							"underline"
						) === true
							? "underline"
							: "none",
				}}
				className={`${baseThemeId}_${
					cue.type
				}_large_text large_text whitespace-pre
                    text-${checkForOverride(
											baseTheme,
											"ticker",
											cue.preset,
											"h1",
											"size"
										)} my-auto
					
										leading-${checkForOverride(baseTheme, "ticker", cue.preset, "h1", "leading")}
										`}
			>
				<ReplaceWithDataSource text={cue.title} styled={true}/>
			</span>
			<span
				style={{
					color: checkForOverride(
						baseTheme,
						"ticker",
						cue.preset,
						"h2",
						"colour"
					),
				}}
				className={`w-full inline-block my-auto
						${cue.title === "" ? "ml-0" : "ml-4"}
						text-${checkForOverride(baseTheme, "ticker", cue.preset, "h2", "size")}
                    `}
			>
				{cue.status === "coming" ||
				cue.status === "onair" ||
				(cue.status === "cuedoff" && !isPreview) ||
				cue.status === "going" ? (
					<ReactTicker
						offset="100"
						speed={cue.speed || 5}
						mode={cue.mode || "chain"}
						move={
							cue.status === "coming" ||
							cue.status === "onair" ||
							(cue.status === "cuedoff" && !isPreview) ||
							cue.status === "going"
						}
					>
						{({ index }) => {
							return (
								<div key={index} className="whitespace-pre">
									{cue.items.map((item, i) => {
										return (
											<span key={i}>
												<span
													style={{
														fontFamily: baseTheme.h2?.font || baseTheme.font?.family,
														fontWeight:
															checkForOverride(
																baseTheme,
																"ticker",
																cue.preset,
																"h2",
																"bold"
															) === true
																? "bold"
																: "normal",
														fontStyle:
															checkForOverride(
																baseTheme,
																"ticker",
																cue.preset,
																"h2",
																"italic"
															) === true
																? "italic"
																: "normal",
														textDecoration:
															checkForOverride(
																baseTheme,
																"ticker",
																cue.preset,
																"h2",
																"underline"
															) === true
																? "underline"
																: "none",
													}}
													className={`${baseThemeId}_${cue.type}_small_text small_text ${baseThemeId}_px small_text px-s3`}
												>
													<ReplaceWithDataSource text={item.body} styled={true} />
												</span>
											</span>
										);
									})}
									{/* 
								 	<img src="www.my-image-source.com/" alt="" /> */}
								</div>
							);
						}}
					</ReactTicker>
				) : null}
			</span>
		</>
	);
}
